import { render, staticRenderFns } from "./list-selection-widget.vue?vue&type=template&id=683367da&scoped=true&"
import script from "./list-selection-widget.vue?vue&type=script&lang=js&"
export * from "./list-selection-widget.vue?vue&type=script&lang=js&"
import style0 from "./list-selection-widget.vue?vue&type=style&index=0&id=683367da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683367da",
  null
  
)

export default component.exports